import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropTypes from 'prop-types';
import { commonStyles as styles } from 'assets/style';

export const SubmitDialog = ({ open, onClose, isSuccess, message, onAddTeamMembers, showAccessFields }) => (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
            sx: {
                width: 600,
                height: 'auto',
                borderRadius: '8px',
            },
        }}
    >
        <Box sx={{ border: (theme) => `10px solid ${theme.palette.border.$color_border_default}` }}>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                    {!showAccessFields && (
                        <>
                            {isSuccess && (
                                <CheckCircleIcon
                                    sx={{
                                        fontSize: '50px',
                                        color: '#005CBC',
                                        marginBottom: '0px',
                                    }}
                                />
                            )}
                            <DialogTitle
                                id="alert-dialog-title"
                                sx={{
                                    marginBottom: '20px',
                                    fontSize: '16px',
                                    color: isSuccess ? 'black' : 'red',
                                }}
                            >
                                {isSuccess ? 'Success' : 'Failed'}
                            </DialogTitle>
                            <Typography
                                sx={{
                                    color: isSuccess ? 'black' : 'red',
                                    fontSize: '14px',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {message}
                            </Typography>
                            <Typography sx={{ marginTop: '20px', fontSize: '16px' }}>Do you want to give project access to the team members?</Typography>

                            <Box sx={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                <Button sx={{ ...styles.modalSaveButton }} variant="contained" disableElevation disableRipple onClick={onAddTeamMembers}>
                                    Yes
                                </Button>
                                <Button sx={{ ...styles.modalCancelButton }} variant="outlined" disableElevation disableRipple onClick={onClose}>
                                    No
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </DialogContent>
        </Box>
    </Dialog>
);

SubmitDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    isSuccess: PropTypes.bool.isRequired,
    message: PropTypes.node.isRequired,
    onAddTeamMembers: PropTypes.func.isRequired,
    showAccessFields: PropTypes.bool.isRequired,
};

export const DeleteDialog = ({ open, onCancel, onConfirm }) => (
    <Dialog
        open={open}
        onClose={onCancel}
        PaperProps={{
            sx: {
                width: '480px',
                background: '#FFFFFF 0% 0% no-repeat padding-box',
                boxShadow: '0px 0px 6px #00000074',
                borderRadius: '4px',
            },
        }}
    >
        <Box
            sx={{
                ...styles.modalWrapper,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <DialogTitle sx={styles.modalTitle}>Confirm Delete</DialogTitle>
            <DialogContent>
                <DialogContentText sx={styles.modalContent}>Are you sure you want to delete the selected model tags?</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', padding: '8px 16px', marginBottom: '10px' }}>
                <Button onClick={onConfirm} disableElevation disableRipple sx={{ ...styles.modalSaveButton, width: '100px' }}>
                    Yes
                </Button>
                <Button onClick={onCancel} sx={{ ...styles.modalCancelButton, width: '100px' }}>
                    No
                </Button>
            </DialogActions>
        </Box>
    </Dialog>
);

DeleteDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
